module.exports = __webpack_public_path__ + "./fonts/Manrope-Bold.ttf";